import { useMemo, useState } from "react";
import { FaExchangeAlt, FaList, FaPlus } from "react-icons/fa";
import { NumericFormat } from "react-number-format";
import moment from "moment";
import { getData, postData } from "../../api/ApiRest";
import {
    Box, Paper, Grid, TextField, MenuItem, Button, Typography, Tooltip, Menu,
} from "@mui/material";
import Swal from "sweetalert2";
import {
    getEmisionPlanCompany,
    recomputeGeneralPlan,
} from "../../components/services/companyAPI";
import GeneralModal from "../../components/common/GeneralModal";
import LoadingComponent from "../../widgets/LoadingComponent";
import HistoricoPlanes from "../../components/common/HistoricoPlanes";
import DetallePlanModal from "../../components/views/DetallePlanModal";
import "moment/locale/es";
import PlanPersonalizado from "../../components/views/components/PlanPersonalizado";
import auditoriaSet from "../../widgets/Auditoria";
import { useInfoUser } from "../../helper/authHelper";

// ── Estilos ───────────────────────────────────────────────────────────────────

const inputSx = {
    '& .MuiInputBase-input': { fontSize: '0.82rem' },
    '& .MuiInputLabel-root': { fontSize: '0.82rem' },
};

const sectionTitleSx = {
    fontWeight: 700,
    fontSize: '0.82rem',
    px: 1.5,
    py: 0.8,
    borderRadius: 1,
    background: '#224B6A',
    color: '#fff',
    letterSpacing: 0.3,
    mb: 1.5,
    display: 'block',
};

// ── Componente principal ──────────────────────────────────────────────────────

function Planes({
    setLoading,
    PlanesDisponibles,
    PlanesActuales = [],
    CompanyId,
    Permiso,
    Es_Cliente,
    Nit,
    NameCompany
}) {
    const [nuevoPlan, setNuevoPlan] = useState({
        Nuevo: false,
        PlanId: "",
        FechaInicio: moment(new Date()).format("yyyy-MM-DD"),
        ValorMes: 0,
        ValorAnual: 0,
        FoliosMes: 0,
        FoliosAnual: 0,
        PagoAnual: "true",
        FacturaPrefijo: "",
        FacturaNumero: "",
        FacturaFecha: moment(new Date()).format("yyyy-MM-DD"),
        Renovacion: false,
        NuevoCiclo: false,
    });

    const [LoadingTwo, setLoadingTwo] = useState(false);
    const [observationMessage, setObservationMessage] = useState("");
    const [modalAlert, setModalAlert] = useState(false);
    const [modalAlertNuevoCiclo, setModalAlertNuevoCiclo] = useState(false);
    const [openDetalleFolios, setOpenDetalleFolios] = useState(false);
    const [emissionPlanPerMonth, setEmissionPlanPerMonth] = useState([]);
    const [planSelected, setPlanSelected] = useState({});
    const [isExtensionPlan, setIsExtensionPlan] = useState(false);
    const [esPersonalizado, setEsPersonalizado] = useState(false);
    const [openFormPersonalizado, setOpenFormPersonalizado] = useState(false);
    const [activarSeleccionFecha, setActivarSeleccionFecha] = useState(false);
    const [menuAnchor, setMenuAnchor] = useState(null);

    const ultimoPlanActivo = useMemo(() => PlanesActuales[0], [PlanesActuales]);

    let porcentajePlanConsumido =
        ultimoPlanActivo?.planId === 23
            ? (ultimoPlanActivo?.foliosConsumidos / ultimoPlanActivo?.foliosCustom) * 100
            : (ultimoPlanActivo?.foliosConsumidos / ultimoPlanActivo?.foliosAnual) * 100;

    const emissionDayPerMonth = async (CompanyPlan) => {
        setLoadingTwo(true);
        const resultEmisionPlan = await getEmisionPlanCompany(CompanyId, CompanyPlan.id);
        setEmissionPlanPerMonth(resultEmisionPlan);
        setLoadingTwo(false);
        setOpenDetalleFolios(true);
    };

    const cancelNewPlan = () => {
        setOpenFormPersonalizado(false);
        setEsPersonalizado(false);
        setIsExtensionPlan(false);
        setNuevoPlan({
            Nuevo: false,
            PlanId: "",
            FechaInicio: moment(new Date()).format("yyyy-MM-DD"),
            ValorMes: 0,
            ValorAnual: 0,
            FoliosMes: 0,
            FoliosAnual: 0,
            PagoAnual: "true",
            FacturaPrefijo: "",
            FacturaNumero: "",
            FacturaFecha: moment(new Date()).format("yyyy-MM-DD"),
        });
    };

    const onChangePlan = (event) => {
        const { value } = event.target;
        if (!value) return alert("Seleccione plan");
        const Plan = PlanesDisponibles.filter((item) => item.id === Number(value));
        const isRewNew = nuevoPlan.Renovacion;
        if (Plan.length === 1) {
            setNuevoPlan({
                ...nuevoPlan,
                PlanId: String(value),
                FoliosAnual: Plan[0].cantidadAno,
                FoliosMes: Plan[0].cantidadMes,
                ValorAnual: isRewNew ? Plan[0].valorAnoRenovacion : PlanesActuales.length > 0 ? Plan[0].valorAnoRenovacion : Plan[0].valorAno,
                ValorMes: isRewNew ? Plan[0].valorMesRenovacion : PlanesActuales.length > 0 ? Plan[0].valorMesRenovacion : Plan[0].valorMes,
            });
        }
    };

    const asociarVentasPlan = () => {
        setLoading(true);
        getData('api/Configuracion/Factura/asociarVenta', { companyId: CompanyId }).then(response => {
            if (response.status) {
                alert(response.msj);
                window.location.reload();
            }
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    };

    const generarFactura = (Plan, tipo = 'C') => {
        setLoading(true);
        if (tipo === 'C') {
            getData('api/Configuracion/Factura/generarFactura', {
                Cliente: Plan.CompanyId,
                Fecha: new Date().toISOString().split('T')[0],
                PlanId: Plan.PlanId,
                prefijo: Plan.FacturaPrefijo,
                valor: Plan.ValorMes
            }).then(response => {
                if (response.status) alert(response.msj);
                setLoading(false);
            }, error => { console.log(error); setLoading(false); });
        } else if (tipo === 'E') {
            getData('api/Configuracion/Factura/generarFactura', {
                Cliente: Plan.companyId,
                Fecha: new Date().toISOString().split('T')[0],
                PlanId: Plan.planId,
                prefijo: Plan.facturaPrefijo,
                valor: Plan.valorMensual
            }).then(response => {
                if (response.status) alert(response.msj);
                setLoading(false);
            }, error => { console.log(error); setLoading(false); });
        }
    };

    const guardarNuevoPlan = async (event) => {
        event.preventDefault();
        setLoadingTwo(true);
        if (!Permiso) {
            alert('No tienes permiso para guardar un nuevo plan');
            setLoading(false);
            return;
        }
        postData("api/Configuracion/Company/UpdatePlan", {
            CompanyId,
            PlanId: nuevoPlan.PlanId,
            FechaIncio: nuevoPlan.FechaInicio,
            ValorMensual: nuevoPlan.ValorMes,
            ValorAnual: nuevoPlan.ValorAnual,
            PagoAnual: nuevoPlan.PagoAnual,
            FacturaNumero: nuevoPlan.FacturaNumero,
            FacturaPrefijo: nuevoPlan.FacturaPrefijo,
            FacturaFecha: nuevoPlan.FacturaFecha,
            ReNueva: nuevoPlan.Renovacion,
            observationText: observationMessage,
            NuevoCiclo: nuevoPlan.NuevoCiclo,
        }, {}).then(async (response) => {
            if (response.status === true) {
                auditoriaSet(nuevoPlan, {}, 'C', 'Empresa', CompanyId, 'Planes');
                await reOrganizarPlanes(CompanyId);
                setTimeout(() => window.location.reload(), 500);
                setLoadingTwo(false);
                Swal.fire({
                    title: "¡Plan creado con éxito!",
                    icon: "success",
                    draggable: true,
                    allowOutsideClick: false,
                }).then(result => {
                    if (result.isConfirmed) window.location.reload();
                });
            } else {
                console.log(response);
                alert(response.msj);
                setLoading(false);
            }
        }, (error) => {
            setLoading(false);
            alert("Algo salio mal por favor veririca");
            console.log(error);
        });
    };

    const handleChangeObservation = (event) => setObservationMessage(event.target.value);

    const openAlertObservation = (item) => {
        setObservationMessage(item.observacion);
        setModalAlert(true);
    };

    const openDetalleFoliosFunc = async (selectedItem) => {
        setPlanSelected(selectedItem);
        emissionDayPerMonth(selectedItem);
    };

    const closeAlertObservation = () => {
        setObservationMessage("");
        setModalAlert(false);
    };

    const NuevoCicloFunc = () => {
        setEsPersonalizado(false);
        setOpenFormPersonalizado(false);
        setModalAlertNuevoCiclo(false);
        setNuevoPlan({ ...nuevoPlan, Nuevo: true, Renovacion: false, NuevoCiclo: true });
    };

    const reOrganizarPlanes = async (companyId) => {
        setLoading(true);
        await recomputeGeneralPlan(companyId);
        setLoading(false);
    };

    const nuevaExtension = async (activarFechaSeleccion) => {
        setOpenFormPersonalizado(false);
        setEsPersonalizado(false);
        setActivarSeleccionFecha(activarFechaSeleccion);
        setIsExtensionPlan(true);
        setNuevoPlan({
            ...nuevoPlan,
            FechaInicio: moment(ultimoPlanActivo.finRenovacion).add(1, "days").format("yyyy-MM-DD"),
            Nuevo: true,
            Renovacion: true,
            NuevoCiclo: false,
        });
    };

    const nuevoPlanPrincipal = (activarFechaSeleccion) => {
        setOpenFormPersonalizado(false);
        setEsPersonalizado(false);
        setActivarSeleccionFecha(activarFechaSeleccion);
        setNuevoPlan({ ...nuevoPlan, Nuevo: true, Renovacion: false });
    };

    const onChangeFechaInicio = async (event) => {
        const { value } = event.target;
        const fechaInicioValue = ultimoPlanActivo?.estado
            ? moment(value).format("yyyy-MM-DD")
            : moment(ultimoPlanActivo?.finRenovacion).add(1, "days").format("yyyy-MM-DD");
        isExtensionPlan
            ? setNuevoPlan({ ...nuevoPlan, FechaInicio: fechaInicioValue, Nuevo: true, Renovacion: true, NuevoCiclo: false })
            : setNuevoPlan({ ...nuevoPlan, FechaInicio: moment(value).format("yyyy-MM-DD") });
    };

    // ── Plan activo ───────────────────────────────────────────────────────────

    const planActual = () => {
        const Actual = PlanesActuales.filter((item) => item.estado === true);

        if (Actual.length === 0) {
            return (
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 2, textAlign: 'center' }}>
                    <Typography color="error" fontWeight={700} fontSize="0.88rem">
                        LA EMPRESA NO TIENE NINGÚN PLAN ACTIVO ACTUALMENTE
                    </Typography>
                </Paper>
            );
        }

        const PlanActual = Actual[0];

        if (esPersonalizado) {
            return (
                <PlanPersonalizado
                    closeWindow={setEsPersonalizado}
                    CompanyId={CompanyId}
                    ultimoPlanActivo={ultimoPlanActivo}
                />
            );
        }

        return (
            <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                <Typography sx={sectionTitleSx}>
                    PLAN ACTIVO — {PlanActual.esPadre ? "PADRE" : "RENOVACIÓN"}
                </Typography>
                <Grid container spacing={1.5}>
                    <Grid item xs={12} md={4}>
                        <TextField label="Plan" fullWidth size="small" sx={inputSx}
                            value={PlanActual.plan} inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField label="Fecha Desde" fullWidth size="small" sx={inputSx}
                            value={moment(PlanActual.fechaInicio).locale('es').format("DD-MMMM-YYYY")}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField label="Fecha Hasta" fullWidth size="small" sx={inputSx}
                            value={moment(PlanActual.fechaFin).locale('es').format("DD-MMMM-YYYY")}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField label="Tipo Pago" fullWidth size="small" sx={inputSx}
                            value={PlanActual.pagoAnual === true ? "Anual" : "Mensual"}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <NumericFormat customInput={TextField}
                            label="Folios Mes" fullWidth size="small" sx={inputSx}
                            thousandSeparator=","
                            value={PlanActual.planId === 23 ? PlanActual.foliosCustom : PlanActual.foliosMes}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <NumericFormat customInput={TextField}
                            label="Folios Anuales" fullWidth size="small" sx={inputSx}
                            thousandSeparator=","
                            value={PlanActual.planId === 23 ? PlanActual.foliosCustom : PlanActual.foliosAnual}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <NumericFormat customInput={TextField}
                            label="Valor Mes" fullWidth size="small" sx={inputSx}
                            thousandSeparator="," prefix="$"
                            value={PlanActual.valorMensual}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <NumericFormat customInput={TextField}
                            label="Valor Anual" fullWidth size="small" sx={inputSx}
                            thousandSeparator="," prefix="$"
                            value={PlanActual.valorAnual}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    {PlanActual.planId === 23 && (
                        <Grid item xs={12} md={3}>
                            <NumericFormat customInput={TextField}
                                label="Precio Folio Unidad" fullWidth size="small" sx={inputSx}
                                thousandSeparator="," prefix="$"
                                value={PlanActual.foliosUndCustom}
                                inputProps={{ readOnly: true }} />
                        </Grid>
                    )}
                    <Grid item xs={12} md={3}>
                        <TextField label="Factura" fullWidth size="small" sx={inputSx}
                            value={`${PlanActual.facturaPrefijo} - ${PlanActual.facturaNumero}`}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField label="Factura Fecha" fullWidth size="small" sx={inputSx}
                            value={moment(PlanActual.facturaFecha).format("DD-MM-YYYY")}
                            inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField label="Observación" fullWidth size="small" sx={inputSx}
                            value={PlanActual?.observacion || ''} inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <Button variant="contained" size="small" color="warning"
                                sx={{ fontSize: '0.78rem' }}
                                onClick={() => generarFactura(PlanActual, 'E')}>
                                Generar factura
                            </Button>
                            <Button variant="outlined" size="small"
                                startIcon={<FaList size={12} />}
                                sx={{ fontSize: '0.78rem', borderColor: '#64748b', color: '#64748b' }}
                                onClick={() => openDetalleFoliosFunc(PlanActual)}>
                                Detalle folios
                            </Button>
                            <Button variant="outlined" size="small"
                                startIcon={<FaExchangeAlt size={12} />}
                                sx={{ fontSize: '0.78rem', borderColor: '#1976d2', color: '#1976d2' }}
                                onClick={() => asociarVentasPlan(PlanActual)}>
                                Asociar facturas
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        );
    };

    // ── Botón nuevo plan ──────────────────────────────────────────────────────

    const btnNuevo = () => {
        if (nuevoPlan.Nuevo !== false || Es_Cliente !== 'true') return null;

        const activePlans = PlanesActuales.filter((item) => item.estado === true).length > 0;

        const menuItems = activePlans
            ? [
                { label: 'Crear plan', onClick: () => nuevoPlanPrincipal(true) },
                ...(PlanesActuales.length > 0 && ultimoPlanActivo.estado == false
                    ? [{ label: 'Renovar plan', onClick: () => nuevaExtension(false) }]
                    : []),
                { label: 'Crear plan personalizado', onClick: () => setEsPersonalizado(true) },
            ]
            : [
                { label: 'Crear plan', onClick: () => nuevoPlanPrincipal(true) },
                ...(PlanesActuales.length > 0 && porcentajePlanConsumido > 100
                    ? [{ label: 'Renovar plan', onClick: () => nuevaExtension(false) }]
                    : []),
                { label: 'Crear plan personalizado', onClick: () => setOpenFormPersonalizado(true) },
            ];

        return (
            <Box sx={{ mb: 2 }}>
                <Button variant="contained" size="small" startIcon={<FaPlus size={11} />}
                    onClick={(e) => setMenuAnchor(e.currentTarget)}
                    sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                    Nuevo Plan
                </Button>
                <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
                    {menuItems.map((item, i) => (
                        <MenuItem key={i} dense sx={{ fontSize: '0.82rem' }}
                            onClick={() => { item.onClick(); setMenuAnchor(null); }}>
                            {item.label}
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
        );
    };

    // ── Render ────────────────────────────────────────────────────────────────

    return (
        <Box>
            <LoadingComponent Loading={LoadingTwo} canClose={true} />

            {Es_Cliente === 'true' ? (
                <>
                    <GeneralModal
                        open={modalAlert}
                        title="Mensaje Observación"
                        message={observationMessage || ""}
                        onClose={closeAlertObservation}
                    />

                    <DetallePlanModal
                        emissionPlanPerMonth={emissionPlanPerMonth}
                        openDetalleFolios={openDetalleFolios}
                        setOpenDetalleFolios={setOpenDetalleFolios}
                        selectedPlanDetail={planSelected}
                        Nit={Nit}
                        NameCompany={NameCompany}
                    />

                    <GeneralModal
                        open={modalAlertNuevoCiclo}
                        title="Nuevo ciclo"
                        message={"¿Estás seguro de iniciar un nuevo ciclo de plan padre e hijos?" || ""}
                        withBtnAction={true}
                        onClickAction={NuevoCicloFunc}
                        onClose={() => setModalAlertNuevoCiclo(false)}
                    />

                    {btnNuevo()}

                    {/* Formulario nuevo plan */}
                    {nuevoPlan.Nuevo === true && (
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                            <Typography sx={sectionTitleSx}>
                                {`NUEVO PLAN${nuevoPlan.Renovacion ? ' — RENOVACIÓN' : ''}`}
                            </Typography>
                            <Box component="form" onSubmit={guardarNuevoPlan}>
                                <Grid container spacing={1.5}>
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Plan" select fullWidth size="small" sx={inputSx}
                                            value={nuevoPlan.PlanId}
                                            onChange={onChangePlan}
                                            required>
                                            <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                            {PlanesDisponibles.map((item, key) => {
                                                const currentYear = moment().year();
                                                if (item.periodo === currentYear) {
                                                    return (
                                                        <MenuItem key={key} value={String(item.id)} sx={{ fontSize: '0.82rem' }}>
                                                            {`${item.codigo} - ${item.nombre} - ${item.periodo}`}
                                                        </MenuItem>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <TextField label="Fecha Inicio" type="date" fullWidth size="small" sx={inputSx}
                                            required InputLabelProps={{ shrink: true }}
                                            disabled={!activarSeleccionFecha}
                                            value={nuevoPlan.FechaInicio}
                                            onChange={onChangeFechaInicio} />
                                    </Grid>
                                    {isExtensionPlan && (
                                        <Grid item xs={12} md={2}>
                                            <TextField label="Fecha Fin" type="date" fullWidth size="small" sx={inputSx}
                                                InputLabelProps={{ shrink: true }} disabled
                                                value={moment(ultimoPlanActivo?.fechaFin).format("yyyy-MM-DD")} />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} md={3}>
                                        <NumericFormat customInput={TextField}
                                            label="Folios Mensuales" fullWidth size="small" sx={inputSx}
                                            thousandSeparator=","
                                            value={nuevoPlan.FoliosMes}
                                            inputProps={{ readOnly: true }} />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <NumericFormat customInput={TextField}
                                            label="Folios Anuales" fullWidth size="small" sx={inputSx}
                                            thousandSeparator=","
                                            value={nuevoPlan.FoliosAnual}
                                            inputProps={{ readOnly: true }} />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <NumericFormat customInput={TextField}
                                            label="Valor Mensual" fullWidth size="small" sx={inputSx}
                                            thousandSeparator="," prefix="$"
                                            value={nuevoPlan.PagoAnual === "true" ? nuevoPlan.ValorAnual / 12 : nuevoPlan.ValorMes}
                                            inputProps={{ readOnly: true }} />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <NumericFormat customInput={TextField}
                                            label="Valor Anual" fullWidth size="small" sx={inputSx}
                                            thousandSeparator="," prefix="$"
                                            value={nuevoPlan.PagoAnual === "true" ? nuevoPlan.ValorAnual : nuevoPlan.ValorMes * 12}
                                            inputProps={{ readOnly: true }} />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Tipo Pago" select fullWidth size="small" sx={inputSx}
                                            value={nuevoPlan.PagoAnual}
                                            onChange={e => setNuevoPlan({ ...nuevoPlan, PagoAnual: e.target.value })}>
                                            <MenuItem value="true" sx={{ fontSize: '0.82rem' }}>Anual</MenuItem>
                                            <MenuItem value="false" sx={{ fontSize: '0.82rem' }}>Mensual</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField label="Factura Prefijo" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 5 }}
                                            value={nuevoPlan.FacturaPrefijo}
                                            onChange={e => setNuevoPlan({ ...nuevoPlan, FacturaPrefijo: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField label="Factura Número" type="number" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off"
                                            value={nuevoPlan.FacturaNumero}
                                            onChange={e => setNuevoPlan({ ...nuevoPlan, FacturaNumero: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField label="Factura Fecha" type="date" fullWidth size="small" sx={inputSx}
                                            required InputLabelProps={{ shrink: true }}
                                            value={nuevoPlan.FacturaFecha}
                                            onChange={e => setNuevoPlan({ ...nuevoPlan, FacturaFecha: moment(e.target.value).format("yyyy-MM-DD") })} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="Observación al renovar plan" fullWidth size="small" sx={inputSx}
                                            value={observationMessage}
                                            onChange={handleChangeObservation} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <Button type="submit" variant="contained" size="small"
                                                    sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                                    Guardar
                                                </Button>
                                                <Button type="button" variant="contained" size="small" color="error"
                                                    sx={{ fontSize: '0.78rem' }}
                                                    onClick={cancelNewPlan}>
                                                    Cancelar
                                                </Button>
                                            </Box>
                                            <Button type="button" variant="contained" size="small" color="warning"
                                                sx={{ fontSize: '0.78rem' }}
                                                onClick={() => generarFactura(nuevoPlan, 'C')}>
                                                Generar factura
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    )}

                    {openFormPersonalizado && (
                        <PlanPersonalizado
                            closeWindow={setOpenFormPersonalizado}
                            CompanyId={CompanyId}
                            ultimoPlanActivo={ultimoPlanActivo}
                        />
                    )}

                    {planActual()}

                    <HistoricoPlanes
                        PlanesActuales={PlanesActuales}
                        openAlertObservation={openAlertObservation}
                        openDetalleFoliosFunc={openDetalleFoliosFunc}
                    />
                </>
            ) : (
                <>
                    <DetallePlanModal
                        emissionPlanPerMonth={emissionPlanPerMonth}
                        openDetalleFolios={openDetalleFolios}
                        setOpenDetalleFolios={setOpenDetalleFolios}
                        selectedPlanDetail={planSelected}
                        Nit={Nit}
                        NameCompany={NameCompany}
                    />

                    <HistoricoPlanes
                        PlanesActuales={PlanesActuales}
                        openAlertObservation={openAlertObservation}
                        openDetalleFoliosFunc={openDetalleFoliosFunc}
                    />
                </>
            )}
        </Box>
    );
}

export default Planes;
